module.exports = __webpack_public_path__ + "static/media/cookmaster.d34f84a2.png";